import React, { FunctionComponent, useEffect } from 'react'
import * as S from './styled'
import { ReactComponent as MoneyBagIcon } from '../../atoms/Icons/money-bag.svg'
import { ReactComponent as WeightIcon } from '../../atoms/Icons/weight.svg'
import { ReactComponent as BrokenEggIcon } from '../../atoms/Icons/cracked-egg.svg'
import { ReactComponent as CashHandIcon } from '../../atoms/Icons/cash-hand.svg'
import { ReactComponent as Eggcelent } from '../../atoms/Icons/eggcelent.svg'
import { ReactComponent as Useless } from '../../atoms/Icons/useless.svg'
import { ReactComponent as Dirty } from '../../atoms/Icons/dirty.svg'
import { BoldText, Heading2, Label1 } from '../../../theme/typography'
import SummaryRow from '../SummaryRow'
import DetailsCardSection from '../DetailsCardSection/DetailsCardSection'
import { EggData } from '../../../redux/requests/products/product.types'
import { useParams } from 'react-router-dom'
import useConnectRequest from '../../../hooks/useConnectRequest'
import { FETCH_DOCUMENT } from '../../../redux/requests/products/product.actions'
import { useDispatch } from 'react-redux'
import { requestActions } from '../../../redux/requests'
import { Product } from '../../../pages/DashBoard/DashBoardScreen'
import { getAuth } from 'firebase/auth'
type OwnProps = {
  doc: any
  loading: boolean
}

type Props = OwnProps

const detailedData = (data: EggData[], type: string) => {
  const total = data.reduce((sum, current) => {
    return {
      totalPrice: sum.totalPrice + current.totalPrice,
      amount: sum.amount + current.amount,
      percentage: sum.percentage + current.percentage,
      price: sum.price + current.price,
      type: type,
    }
  }) as EggData
  total.price = total.price / 4
  data.unshift(total)

  return data
}

export const EggSingleDocument = () => {
  let summaryRowData
  let sectionLeft
  let sectionRight
  console.log('YEEEEEHAA')
  const { docId } = useParams<{ docId: string }>()
  const dispatch = useDispatch()
  const auth = getAuth()
  const userId = auth.currentUser?.uid
  const { data, loading, error } = useConnectRequest(FETCH_DOCUMENT)
  useEffect(() => {
    dispatch(requestActions.products.fetchDocument(userId!, docId, Product.EGG))
  }, [])
  const document: any = data
  if (!loading && document) {
    if (document.data) {
      summaryRowData = [
        {
          label: 'Nettopris/kg',
          value: document.avgPricePerKg,
          icon: <MoneyBagIcon />,
        },
        {
          label: 'Nettopris/st',
          value: document.avgPrice,
          icon: <MoneyBagIcon />,
        },
        {
          label: 'Medelvikt',
          value: document.avgWeight,
          icon: <WeightIcon />,
        },
        {
          label: 'Knäck',
          value: document.data.find(obj => obj.type === 'broken')
            ? document.data.find(obj => obj.type === 'broken')?.percentage
            : '0',
          icon: <BrokenEggIcon />,
        },
        {
          label: 'Smuts',
          value: document.data.find(obj => obj.type === 'dirty')
            ? document.data.find(obj => obj.type === 'dirty')?.percentage
            : '0',
          icon: <Dirty />,
        },
        {
          label: 'Odugliga',
          value: document.data.find(obj => obj.type === 'unacceptable')
            ? document.data.find(obj => obj.type === 'unacceptable').percentage
            : '0',
          icon: <Useless />,
        },
      ]
      sectionLeft = detailedData(document.data.slice(0, 4), 'classASummary')
      sectionRight = detailedData(document.data.slice(4, 8), 'totalDiscarded')
    }
  }
  return (
    <S.ScreenWrapper>
      {!loading && document?.data && (
        <>
          <S.CardWrapper>
            <S.Card>
              <Eggcelent />
              <S.Text>
                <BoldText>Kvalitetsklass A Total</BoldText>
                <Label1>
                  {sectionLeft[0].totalPrice ? sectionLeft[0].totalPrice.toLocaleString('fr') : '0'}{' '}
                  Kr
                </Label1>
              </S.Text>
            </S.Card>
            <S.Card>
              <BrokenEggIcon />
              <S.Text>
                <BoldText>Frånsorterat Total</BoldText>
                <Label1>
                  {sectionRight[0].totalPrice
                    ? sectionRight[0].totalPrice.toLocaleString('fr')
                    : '0'}{' '}
                  Kr
                </Label1>
              </S.Text>
            </S.Card>
            <S.Card>
              <CashHandIcon />
              <S.Text>
                <BoldText>Total</BoldText>
                <Label1>
                  {(sectionLeft[0].totalPrice + sectionRight[0].totalPrice).toLocaleString('fr')} Kr
                </Label1>
              </S.Text>
            </S.Card>
          </S.CardWrapper>
          <S.Container>
            <S.Title>
              <Heading2 left>Sammanställning</Heading2>
            </S.Title>
            <S.SummaryDataWrapper>
              <SummaryRow singleDocumentData={summaryRowData} />
            </S.SummaryDataWrapper>
            <S.Title>
              <Heading2 left>Detaljer</Heading2>
            </S.Title>
            <S.DataLeftStyled>
              <DetailsCardSection
                details={detailedData(document.data.slice(0, 4), 'classASummary')}
              />
            </S.DataLeftStyled>
            <S.DataLeftStyled>
              <DetailsCardSection
                details={detailedData(document.data.slice(4, 8), 'totalDiscarded')}
              />
            </S.DataLeftStyled>
          </S.Container>
        </>
      )}
    </S.ScreenWrapper>
  )
}

export default EggSingleDocument
